/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Email-template admin list and editor.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {CodemirrorModule} from '../../common/directives/codemirror.module';
import {EmailTemplateEditPageComponent} from './email-template-edit-page.component';
import {EmailTemplateListPageComponent} from './email-template-list-page.component';
import {EmailTemplateRoutePageComponent} from './email-template-route-page.component';

const EMAIL_TEMPLATE = [
  EmailTemplateEditPageComponent,
  EmailTemplateListPageComponent,
  EmailTemplateRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdminListModule,
    CodemirrorModule
  ],
  declarations: EMAIL_TEMPLATE,
  exports: EMAIL_TEMPLATE
})
export class EmailTemplateModule {
}
